<template>
  <a :href="business.route">
    <div
      class="business-list-card"
      :class="{ 'is-active': activeBusiness === business.id }"
    >
      <div class="business-list-card__content">
        <section class="custom-d-flex">
          <a
            v-for="(category, index) in business.categories"
            :key="category.id"
            :href="category.route"
          >
            <span
              class="business-list-card__category custom-pr-3"
              v-html="index !== business.categories.length -1?highlightKeyword(category.name+', '):highlightKeyword(category.name)"
            />
          </a>
        </section>

        <h3 class="business-list-card__heading business-list-card__heading--h3">
          <a
            :href="business.route"
            class="business-list-card__heading-link"
            style="word-break: break-word;"
            v-html="highlightKeyword(business.name)"
          />
        </h3>

        <p
          v-if="business.excerpt"
          class="business-list-card__paragraph"
          v-html="highlightKeyword(business.excerpt)"
        />

        <p
          v-show="business.hide_address === 0"
          v-if="business.address_1"
          class="business-list-card__address icon icon__address"
        >
          <span
            v-html="
              highlightKeyword(
                business.address_1 +
                  ', ' +
                  (business.address_2 ? business.address_2 + ', ' : '') +
                  business.city +
                  ', ' +
                  business.state_province,true
              )
            "
          />
        </p>
        <p
          v-if="business.phone"
          class="business-list-card__phone icon icon__phone"
        >
          <a :href="`tel:+${business.phone}`">{{ business.phone }}</a>
        </p>

        <p class="business-list-card__buttons">
          <a
            :href="business.route"
            class="business-list-card__button business-list-card__button--blue"
          >Learn More</a>
          <a
            v-if="business.website"
            :href="business.website"
            target="_blank"
            rel="dofollow"
            class="business-list-card__button business-list-card__button--outline"
          >Website</a>
        </p>
      </div>

      <div
        v-if="business.is_member"
        class="business-list-card__image-container"
      >
        <div
          v-if="business.is_member"
          class="ribbon__container ribbon__container--right"
        >
          <div class="ribbon ribbon--right">Member</div>
        </div>
        <div class="business-list-card__image-wrapper">
          <div
            v-if="business.banner_image"
            v-lazy:background-image="`/storage/${business.banner_image}`"
            class="business-list-card__image"
          />
          <div
            v-else
            class="business-list-card__image"
            :style="{
              backgroundImage: `url('/img/placeholder/profile-placeholder-square.svg')`,
            }"
          />
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    business: { required: true, type: Object },
    activeBusiness: { default: null, required: false, type: Number },
    keyword: { default: null, required: false, type: String },
  },
  methods: {
    highlightKeyword(value,isAddress=false) {
        if(isAddress){
            value = value.replaceAll(', null','');
        }
      // this.keyword needs to be split to show multiple terms
      const keywordRegex = new RegExp(this.keyword, 'i');
      if (this.keyword && keywordRegex.test(value)) {
        value = value.toString().replace(keywordRegex, (matchedText, a, b) => {
          if (matchedText) {
            return (
              '<span class="business-list-card__heading-highlight">' +
              matchedText +
              '</span>'
            );
          } else {
            return matchedText;
          }
        });
      }
      return value;
    },
  },
};
</script>
